// @ts-check
import { observer } from 'mobx-react-lite';
import React from 'react';
import { ShippingCountryState } from 'src/scripts/utils/shipping';
import { toLocalCurrencyShowEstimate } from '../../../utils/currency';
import { ReviewsBottomLine } from './Reviews';
import { IProduct } from '../types/PDP';
import { getGCMinMaxPrice, isHandbagPDPTemplate } from 'src/scripts/templates/product/utils';
import { gatedSaleState } from './GatedSaleProductPrice/state';
import GatedSaleProductPrice from './GatedSaleProductPrice';

// ? [REVISIT] does `isFinalSale` not need to be used?
let Price = (props: {
  actualPrice: number;
  displayPrice: number;
  isFinalSale: boolean;
  withReviews?: boolean;
  product: IProduct;
  colorwayProductId?: string;
  productHandle?: string;
}) => {
  const { actualPrice, displayPrice, withReviews = true, product, colorwayProductId, productHandle } = props;
  //#region ref: ECOM-1721
  const userPreferredCountry = ShippingCountryState.countryCode;
  const isUserPreferredCountryIsrael = userPreferredCountry && userPreferredCountry === 'IL';
  const showAdditionalGEClass = isUserPreferredCountryIsrael && actualPrice < 75;
  //#endregion

  const gcMinMaxPrice = getGCMinMaxPrice(product);
  const enabledGatedSalePricing =
    displayPrice &&
    actualPrice &&
    actualPrice < displayPrice &&
    product.productType !== 'Gift Card' &&
    gatedSaleState.getGatedSaleVisibilityConfig.shouldShowGatedSalePricing;

  const memberGatedEnabled = gatedSaleState.memberGatedSaleConfig.isEnabled;
  const hardMarkSaleEnabled = gatedSaleState.hardMarkSaleConfig.isEnabled;

  return (
    <div className={`price__wrapper ${showAdditionalGEClass ? 'ge_lt_minimum_price' : ''}`}>
      {enabledGatedSalePricing ? (
        <GatedSaleProductPrice price={actualPrice} compareAtPrice={displayPrice} />
      ) : (
        <div className={`Price ${memberGatedEnabled ? 'member-gated' : hardMarkSaleEnabled ? 'hard-mark-sale' : ''}`}>
          <span
            className={`product__price${
              actualPrice < displayPrice ? ' sale__price' : ''
            } large-p semibold d-inline-block d-md-none`}
            data-currency
            tabIndex={0}
          >
            {product?.productType === 'Gift Card' && gcMinMaxPrice?.priceMin && gcMinMaxPrice?.priceMax
              ? `${toLocalCurrencyShowEstimate(gcMinMaxPrice?.priceMin)} - ${toLocalCurrencyShowEstimate(
                  gcMinMaxPrice?.priceMax
                )}`
              : toLocalCurrencyShowEstimate(actualPrice)}
          </span>
          {actualPrice < displayPrice && (
            <span
              className="product__price product__price--sale large-p semibold d-inline-block d-md-none"
              tabIndex={0}
              aria-label={`Original price: ${toLocalCurrencyShowEstimate(displayPrice)}`}
            >
              <s>{toLocalCurrencyShowEstimate(displayPrice)}</s>
            </span>
          )}
          <span
            className={`product__price${
              actualPrice < displayPrice ? ' sale__price' : ''
            } body-large uppercase d-none d-md-inline-block`}
            data-currency
            tabIndex={0}
          >
            {product?.productType === 'Gift Card' && gcMinMaxPrice?.priceMin && gcMinMaxPrice?.priceMax
              ? `${toLocalCurrencyShowEstimate(gcMinMaxPrice?.priceMin)} - ${toLocalCurrencyShowEstimate(
                  gcMinMaxPrice?.priceMax
                )}`
              : toLocalCurrencyShowEstimate(actualPrice)}
          </span>
          {actualPrice < displayPrice && (
            <span
              className="product__price product__price--sale h6 uppercase d-none d-md-inline-block"
              tabIndex={0}
              aria-label={`Original price: ${toLocalCurrencyShowEstimate(displayPrice)}`}
            >
              <s>{toLocalCurrencyShowEstimate(displayPrice)}</s>
            </span>
          )}
        </div>
      )}
      {withReviews && !isHandbagPDPTemplate() && (
        <ReviewsBottomLine colorwayProductId={colorwayProductId} productHandle={productHandle} />
      )}
    </div>
  );
};
Price = observer(Price);

export default Price;
